/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
export const baseFontSize = 16;

export var calculatedBaseFontSize = getCalculatedBaseFontSize();
function getCalculatedBaseFontSize() {
  var calculatedBaseFontSize = parseFloat(
    window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size')
  );
  return calculatedBaseFontSize;
}
